// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__cvDvx","emails":"CreateEditClinics_emails__3KMPB","emailTagLabel":"CreateEditClinics_emailTagLabel__1aBgK"};